import React from 'react';
import TablaNosotros from '../../components/tables/Nosotros';

const Nosotros = () => {
    return (
        <TablaNosotros/>
    );
}
 
export default Nosotros;